import { z } from 'zod'

// One form serves both modes, so `name` is optional in the shared shape and
// required only by the sign-up schema. Rules mirror the Rails side (Devise
// enforces a 6-character password minimum).
export const signInSchema = z.object({
  email: z.email('Enter a valid email address'),
  password: z.string().min(1, 'Enter your password'),
  name: z.string().optional(),
})

export const signUpSchema = z.object({
  email: z.email('Enter a valid email address'),
  password: z.string().min(6, 'Use at least 6 characters'),
  name: z.string().min(1, 'Enter your name'),
})

export type AuthValues = z.infer<typeof signInSchema>
